<div  *ngIf="transform" class="mt-3 ml-2" style="font-size: 14px;" >
  <h6 style="font-size: 16px;color: #666;"> {{'MAP.TERRAIN.CALCULATION' | translate }} <br><br>
     </h6>
     {{'MAP.TERRAIN.COMPARE_FILE' | translate }} <br><br>
  {{transform.ds_name}} <br><br>  {{'MAP.TERRAIN.WITH_FILE' | translate }} <br><br>
  <mat-select *ngIf="transform" [placeholder]="'MAP.TERRAIN.SELECT_TERRAIN' | translate" class="mt-3" style="width: 160px;"  [(ngModel)]="selectedDesignTransformB" >
    <ng-container *ngFor="let item of allSceneTransformsB">
      <mat-option *ngIf="item.id !== transform.id" [value]="item" >
        {{item.ds_name}}
      </mat-option>
    </ng-container>
  </mat-select>
  <mat-divider class="m-2"></mat-divider>
  <div class="mt-3">
    <button mat-raised-button color="primary" [disabled]="!selectedDesignTransformB" type="button" (click)="compare()" class="ml-1">{{ 'GENERIC.COMPARE' | translate }}</button>
    <button mat-raised-button type="button" (click)="cancel()"  class="ml-1">{{ 'GENERIC.CANCEL' | translate }}</button>
  </div>
  <div translate class="mt-3">MAP.TERRAIN.RESULT
    <span  *ngIf="transform && selectedDesignTransformB">
      as  <br> "{{transform.ds_name}} - {{selectedDesignTransformB.ds_name}}"
    </span>
  </div>

</div>

<!-- This seems to be duplicate of above?
<div  *ngIf="!transform" class="mt-3 ml-2" style="font-size: 14px;" >
  <h6 class="primary pt-2"> Calculate the difference between two terrain models </h6> <br><br>
    Comparing: <br><br>
    <mat-select (selectionChange)="selectedDesignTransformB = undefined"  [placeholder]="'MAP.TERRAIN.SELECT_TERRAIN' | translate" class="mt-3" style="width: 160px;"  [(ngModel)]="selectedDesignTransformA" >
      <ng-container *ngFor="let item of allSceneTransformsA">
        <mat-option  [value]="item" >
          {{item.ds_name}}
        </mat-option>
      </ng-container>
    </mat-select>
    <br><br> With: <br><br>
  <mat-select   [placeholder]="'MAP.TERRAIN.SELECT_TERRAIN' | translate" class="mt-3" style="width: 160px;"  [(ngModel)]="selectedDesignTransformB" >
    <ng-container *ngFor="let item of allSceneTransformsB">
      <mat-option [disabled]="!selectedDesignTransformA || (selectedDesignTransformA && item.id === selectedDesignTransformA.id)" [value]="item" >
        {{item.ds_name}}
      </mat-option>
    </ng-container>
  </mat-select>
  <mat-divider class="m-2"></mat-divider>
  <div class="mt-3">
    <button mat-raised-button color="primary" [disabled]="!selectedDesignTransformA || !selectedDesignTransformB" type="button" (click)="compare()" class="ml-1">{{ 'GENERIC.COMPARE' | translate }}</button>
    <button mat-raised-button type="button" (click)="cancel()"  class="ml-1">{{ 'GENERIC.CANCEL' | translate }}</button>
  </div>
  <div class="mt-3">
    The result will be available in a new scene.
    <span  *ngIf="selectedDesignTransformA && selectedDesignTransformB">
      as  <br> "{{selectedDesignTransformA.ds_name}} - {{selectedDesignTransformB.ds_name}}"
    </span>
  </div>
</div>
-->

